import i18n from "@/lang";

const PASSWORD_ERROR_MAP = {
	"Password must contain an uppercase letter": "panel.password.errors.upper",
	"Password must contain a lowercase letter": "panel.password.errors.lower",
	"Password must contain a digit": "panel.password.errors.digit",
	"Password must contain a special character": "panel.password.errors.special",
	"Password must not contain the user account": "panel.password.errors.account",
	"Password must not contain 4 adjacent alphabet or keyboard characters": "panel.password.errors.sequence",
	"Password was already used in recent password history": "panel.password.errors.history",
};

const STATUS_ERROR_MAP = {
	PASSWORD_POLICY: "panel.password.errors.policy",
	PASSWORD_HISTORY: "panel.password.errors.history",
	RESET_TOKEN_INVALID: "panel.password.errors.resetTokenInvalid",
	TEMPORARY_PASSWORD_USED: "panel.password.errors.temporaryUsed",
	ACCESS_LOCKED: "panel.password.errors.accessLocked",
	PASSWORD_RESET_ERROR: "panel.password.errors.passwordResetFailed",
	PASSWORD_CHANGE_ERROR: "panel.password.errors.passwordChangeFailed",
	"Invalid params": "panel.password.errors.invalidParams",
	"Invalid password": "panel.password.errors.invalidParams",
	"Invalid current password": "panel.password.errors.invalidCurrentPassword",
	Forbidden: "panel.password.errors.forbidden",
	"User Already Exist.": "panel.users.userAlreadyExists",
	"All input is required": "panel.password.errors.invalidParams",
};

const translate = (key, params = {}) => i18n.global.t(key, params);

const mapPasswordError = (message) => {
	const value = String(message || "");
	const minLengthMatch = value.match(/^Password must contain at least (\d+) characters$/);

	if (minLengthMatch) {
		return translate("panel.password.errors.minLength", { count: minLengthMatch[1] });
	}

	if (PASSWORD_ERROR_MAP[value]) {
		return translate(PASSWORD_ERROR_MAP[value]);
	}

	return value;
};

export const getErrorMessages = (error) => {
	const data = error?.response?.data;
	const messages = [];

	if (Array.isArray(data?.errors)) {
		messages.push(...data.errors.map(mapPasswordError));
	}

	if (data?.status && STATUS_ERROR_MAP[data.status]) {
		const statusMessage = translate(STATUS_ERROR_MAP[data.status]);

		if (!messages.includes(statusMessage)) {
			messages.unshift(statusMessage);
		}
	} else if (typeof data?.status === "string" && !messages.length) {
		messages.push(data.status);
	}

	if (!messages.length && typeof data?.error === "string" && STATUS_ERROR_MAP[data.error]) {
		messages.push(translate(STATUS_ERROR_MAP[data.error]));
	}

	if (!messages.length && error?.message) {
		messages.push(error.message);
	}

	return messages.length ? messages : [ translate("panel.password.errors.generic") ];
};

export const getErrorMessage = (error) => getErrorMessages(error).join("\n");
